import styled from 'styled-components'
import { ContainerStyle } from '@styles'

export const LabelContainer = styled.div`
  margin: 20px 0;
  ${ContainerStyle}
`
